import { render, staticRenderFns } from "./DetalhesProduto.vue?vue&type=template&id=2bd6756d&scoped=true"
import script from "./DetalhesProduto.vue?vue&type=script&lang=js"
export * from "./DetalhesProduto.vue?vue&type=script&lang=js"
import style0 from "./DetalhesProduto.vue?vue&type=style&index=0&id=2bd6756d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd6756d",
  null
  
)

export default component.exports